import React from 'react';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

const StyledBadge = withStyles(theme => ({
  badge: {
    right: -3,
    top: 5,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))(Badge);

export default function CustomizedBadges(props) {
  return (
    <IconButton onClick={props.onClick} style={props.iconStyle}>
      <StyledBadge
        color="primary"
        badgeContent={props.content}
        style={props.style}
      >
        {props.icon}
      </StyledBadge>
    </IconButton>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/badge/styledBadge.js